import React, { FC } from 'react';
import classNames from 'classnames';

import { modalHeaderStyles } from './styles.css';
import ModalCloseButton from '../ModalCloseButton';

export const MODAL_HEADER_ID = 'modal_header';

type ModalHeaderProps = {
  className?: string;
  onRequestClose?: () => void;
};

const ModalHeader: FC<ModalHeaderProps> = ({ className, onRequestClose, children }) => (
  <div className={classNames(modalHeaderStyles, className)} id={MODAL_HEADER_ID}>
    {onRequestClose && <ModalCloseButton onClick={onRequestClose} />}
    {children}
  </div>
);

export default ModalHeader;
